(ns frontend.view.settings2.contact-lists.contact-list
  (:require [clojure.set :as set]
            [common.entity :as entity]
            [common.localization :as loc]
            [frontend.actions.entity :as entity-actions]
            [frontend.page-components.default-page-layout :as default-page-layout]
            [frontend.page-components.zap-toolbar :as zap-toolbar]
            [frontend.routing :as routing]
            [frontend.state.current-session :as session]
            [frontend.view.not-found :as not-found]
            [frontend.view.settings2.contact-lists.event :as event]
            [frontend.view.settings2.contact-lists.sub :as sub]
            [frontend.view.settings2.sales-pipelines.db :as db]
            [re-frame.core :as rf]
            [reagent.core :as r]
            [ui.components.breadcrumbs.view :as breadcrumbs]
            [ui.components.button.view :as button]
            [ui.components.combo-box.view :as combo-box]
            [ui.components.modal.view :as modal]
            [ui.editors.labelled-input.view :as labelled-input]))

(defn breadcrumbs
  [title]
  [breadcrumbs/container
   [breadcrumbs/item
    {:on-click (fn [_e]
                 (routing/set-view! [:account-settings :tab-key "config"]))}
    (loc/tr :settings/account-settings)]
   [breadcrumbs/item
    {:on-click (fn [_e]
                 (routing/set-view! [:settings/contact-lists]))}
    (loc/tr :settings/contact-lists)]
   [breadcrumbs/item
    {:active? true}
    title]])

(defn card
  [content]
  [:div
   content])

(defn error-text-el
  [text]
  [:span
   {:class "text-sm text-danger-light-text"}
   text])

(defn field-editor-label
  [text]
  [:span
   {:class ""}
   text])

(defn field-editor
  "Wrapper for supporting external validation and error text"
  [props]
  (let [error-text (:error-text props)]
    [:<>
     [labelled-input/view
      props]
     (when error-text
       [error-text-el error-text])]))


(defn contact-list-view
  [{:keys [contact-list get-contact-list change-field-value! update-field-value validation-errors edit-mode?]}]
  (let [{:keys [contact-list/title
                contact-list/description]}
        contact-list
        member-ids (:contact-list/members contact-list)
        current-member-ids (fn []
                             (set (:contact-list/members (get-contact-list))))
        new-members-options
        (->> (session/active-accounts nil)
             (concat @session/persons)
             (keep (fn [entity]
                     (let [id (:db/id entity)
                           label (entity/display-string entity)]
                       (when-not (some #{id} member-ids)
                         {:value id
                          :label label})))))]
    [:div
     {:class "flex flex-col gap-4"}
     [:div
      {:class "flex flex-col gap-4"}
      [:div
       [field-editor
        {:data-type  :data.type/text-simple
         :label      (loc/tr :title)
         :read-only? (not edit-mode?)
         :value      title
         :on-change  (fn [new-value]
                       (update-field-value :contact-list/title new-value))
         :on-blur    (fn [new-value]
                       (change-field-value! :contact-list/title new-value))}]]
      [:div
       [field-editor
        {:data-type  :data.type/text-simple
         :label      (loc/tr :description)
         :read-only? (not edit-mode?)
         :value      description
         :on-change  (fn [new-value]
                       (update-field-value :contact-list/description new-value))
         :on-blur    (fn [new-value]
                       (change-field-value! :contact-list/description new-value))}]]]
     [:div
      {:class "flex flex-col gap-4"}
      [:div
       {:class "flex justify-between items-center"}
       [:span
        {:class "text-xl font-bold"}
        (loc/tr :members)]
       [:div
        [combo-box/view
         {:options   new-members-options
          :on-change (fn [entity-id]
                       (let [new-member-ids (set/union (current-member-ids) #{entity-id})]
                         (change-field-value! :contact-list/members new-member-ids)))}
         [button/sm-primary-solid
          {:size :small}
          [:i.fal.fa-plus]
          (loc/tr :add-members)]]]]

      [:div
       (if (seq member-ids)
         [:div
          {:class "border border-solid border-base-light-border-paler rounded-lg overflow-x-auto"}
          [:table
           {:class "min-w-full divide-y divide-solid divide-base-light-border-paler"}
           [:thead
            [:tr
             {:class "*:px-3 *:py-3.5 *:text-left *:text-sm *:font-semibold *:text-base-light-text"}
             [:th
              (loc/tr :name)]
             [:th
              (loc/tr :email)]
             [:th
              ""]]]
           [:tbody
            {:class "divide-y divide-solid divide-base-light-border-paler"}
            (->> member-ids
                 (sort-by (fn [entity-id]
                            (-> entity-id
                                (session/get-entity)
                                (entity/display-string))))
                 (map
                  (fn [entity-id]
                    (let [entity (session/get-entity entity-id)
                          label (entity/display-string entity)
                          email (or (:account/email entity)
                                    (:person/universal-email-address entity))]
                      ^{:key (str "member-" entity-id)}
                      [:tr
                       {:class "*:px-3 *:py-3 *:whitespace-nowrap *:text-sm *:text-base-light-text *:align-middle"}
                       [:td label]
                       [:td email]
                       [:td
                        {:class "*:ml-auto"}
                        [button/square-secondary-open
                         {:class    "mb-0"
                          :on-click (fn []
                                      (let [new-member-ids (set/difference (current-member-ids) #{entity-id})]
                                        (change-field-value! :contact-list/members new-member-ids)))}
                         [:i.fal.fa-trash]]]])))
                 (doall))]]]
         [:p (loc/tr :no-members-yet)])
       (when (get validation-errors :contact-list/members)
         [error-text-el (get validation-errors :contact-list/members)])]]]))

(defn toolbar-items-renderer
  [{:keys [view-mode]}]
  [:div
   (when-not (= view-mode :create)
     [button/sm-danger-solid
      {:on-click #(rf/dispatch [::event/set-delete-confirmation-dialog-open true])}
      [:i.fal.fa-trash]
      (loc/tr :delete)])])

(defn component
  [{:keys [_route-id]}]
  (let [editor-state (r/atom {:edit-mode?        false
                              :contact-list      {:entity/type :entity.type/contact-list}
                              :validation-errors nil})]
    (r/create-class
     {:component-did-mount    (fn [])
      :component-will-unmount (fn []
                                (rf/dispatch [::event/set-edit-mode false]))
      :reagent-render
      (fn [{:keys [route-id]}]
        (let [view-mode (cond
                          (= route-id "create-new") :create
                          (:edit-mode? @editor-state) :edit
                          :else :view)
              entity-id (when-not (js/isNaN (js/parseInt route-id))
                          (js/parseInt route-id))
              get-contact-list (fn []
                                 (if (some #{view-mode} [:create :edit])
                                   (:contact-list @editor-state)
                                   (session/get-entity entity-id)))
              contact-list (if (some #{view-mode} [:create :edit])
                             (:contact-list @editor-state)
                             @(r/track session/get-entity entity-id))
              delete-confirmation-dialog? @(rf/subscribe [::sub/delete-confirmation-dialog-open?])
              validation-errors (:validation-errors @editor-state)
              create-mode? (= view-mode :create)
              page-title (if (= view-mode :create)
                           (loc/tr :new-contact-list)
                           (:contact-list/title contact-list))
              update-field-value (fn [attr value]
                                   (swap! editor-state assoc-in [:contact-list attr] value))
              change-field-value!
              (fn [attr value]
                (if (= view-mode :create)
                  (swap! editor-state assoc-in [:contact-list attr] value)
                  (entity-actions/optimistic-field-update entity-id
                                                          attr
                                                          value
                                                          session/entities
                                                          (fn [_])
                                                          (fn [_]))))
              validate-contact-list-data
              (fn [contact-list]
                (let [title (:contact-list/title contact-list)
                      members (:contact-list/members contact-list)
                      validation-errors
                      (->> (concat (when (or (not title)
                                             (= title ""))
                                     [[:contact-list/title (loc/tr :required)]])
                                   (when (or (not members)
                                             (empty? members))
                                     [[:contact-list/members (loc/tr :add-at-least-one-member)]]))
                           (into {}))
                      validation-errors (if (empty? validation-errors)
                                          nil
                                          validation-errors)]
                  (swap! editor-state assoc :validation-errors validation-errors)
                  (if validation-errors
                    false
                    true)))
              create-contact-list! (fn []
                                     (let [contact-list (:contact-list @editor-state)]
                                       (when (validate-contact-list-data contact-list)
                                         (rf/dispatch [::event/create-contact-list contact-list]))))]
          [:<>
           [zap-toolbar/view
            db/state
            (partial breadcrumbs page-title)
            nil
            nil
            (partial toolbar-items-renderer {:view-mode view-mode})]
           [:div
            {:class "px-4 py-6 lg:mx-auto lg:w-5xl"}
            [:div
             [:div
              [card
               [:<>
                [contact-list-view
                 {:contact-list        contact-list
                  :get-contact-list    get-contact-list
                  :update-field-value  update-field-value
                  :change-field-value! change-field-value!
                  :validation-errors   validation-errors
                  :edit-mode?          (or (= view-mode :create)
                                           (= view-mode :edit))}]
                (when create-mode?
                  [:div
                   {:class "mt-4 flex gap-3 justify-end"}
                   [button/secondary-hollow
                    {:on-click #(routing/set-view! [:settings/contact-lists])}
                    (loc/tr :cancel)]
                   [button/primary-solid
                    {:on-click create-contact-list!}
                    (loc/tr :create)]])]]]]]

           [modal/view
            {:visible?      delete-confirmation-dialog?
             :hide!         #(rf/dispatch [::event/set-delete-confirmation-dialog-open false])
             :backdrop      "static"
             :close-button? true}
            [:h4
             (loc/tr :delete)]
            [:p
             {:class "mb-3"}
             (loc/tr :delete-entity-confirmation [(loc/tr :entity.type/contact-list)])]
            [:div
             {:class "w-full flex justify-between gap-4"}
             [button/secondary-hollow
              {:on-click #(rf/dispatch [::event/set-delete-confirmation-dialog-open false])}
              (loc/tr :cancel)]
             [button/danger-solid
              {:on-click #(rf/dispatch [::event/disable-contact-list! entity-id])}
              (loc/tr :delete)]]]]))})))

(defmethod routing/render-view :settings/contact-list
  [{:keys [route-params]}]
  (let [route-id (-> route-params
                     :id)]
    (if (session/contact-lists?)
      [default-page-layout/view
       [component {:route-id route-id}]]
      [not-found/not-found-view])))
